module.exports = __webpack_public_path__ + "static/media/profile.b9b95513.svg";